var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialImpairmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E87722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.75C10.44 5.75 6.75 9.4475 6.75 14V20.885C6.75 21.6425 7.3575 22.25 8.115 22.25H15C19.56 22.25 23.25 18.56 23.25 14C23.25 9.4475 19.56 5.75 15 5.75ZM15 20.75H8.25V14C8.25 10.2725 11.2725 7.25 15 7.25C18.7275 7.25 21.75 10.2725 21.75 14C21.75 17.7275 18.7275 20.75 15 20.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.75C10.44 5.75 6.75 9.4475 6.75 14V20.885C6.75 21.6425 7.3575 22.25 8.115 22.25H15C19.56 22.25 23.25 18.56 23.25 14C23.25 9.4475 19.56 5.75 15 5.75ZM15 20.75H8.25V14C8.25 10.2725 11.2725 7.25 15 7.25C18.7275 7.25 21.75 10.2725 21.75 14C21.75 17.7275 18.7275 20.75 15 20.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2115 14.4615C16.2115 15.1383 15.6768 15.6731 15 15.6731C14.3232 15.6731 13.7885 15.1383 13.7885 14.4615C13.7885 13.7931 14.3316 13.25 15 13.25C15.6768 13.25 16.2115 13.7847 16.2115 14.4615Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1731 14.4615C12.1731 15.1383 11.6365 15.6731 10.9573 15.6731C10.2782 15.6731 9.75 15.1383 9.75 14.4615C9.75 13.7931 10.295 13.25 10.9657 13.25C11.6449 13.25 12.1731 13.7847 12.1731 14.4615Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 14.4615C20.25 15.1383 19.7152 15.6731 19.0385 15.6731C18.37 15.6731 17.8269 15.13 17.8269 14.4615C17.8269 13.7931 18.37 13.25 19.0385 13.25C19.7236 13.25 20.25 13.7847 20.25 14.4615Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialImpairmentIcon);
export default __webpack_public_path__ + "static/media/socialImpairmentIcon.f45ef2c8ce6e41d3be5d3ced01c54631.svg";
export { ForwardRef as ReactComponent };